<template lang="html">
	<div>
    <vs-card>
      <div slot="header">
        <h3 class='float-left'>Message Preview</h3>
        <router-link :to="{name:'CampaignView', params: {id: $route.params.id}}" custom v-slot="{navigate}">
          <vs-button class='float-right' @click='navigate'>{{ $t('Back') }}</vs-button>
        </router-link>
      </div>
      <div>&nbsp;</div>
    </vs-card>

    <vs-card>
      <div slot="header">
        <h3>Subject</h3>
      </div>
      <section v-html='subject'></section>
    </vs-card>

    <vs-card>
      <div slot="header">
        <h3>Message</h3>
      </div>
      <section v-html='message'></section>
    </vs-card>
	</div>

</template>

<script>
import { previewMessage } from '@/api/campaign';

export default {
	data: () => ({
    message: null,
    subject: null
  }),
	async created() {
		this.$vs.loading();
    await this.preview()
		this.$vs.loading.close();
	},
	methods: {
    async preview() {
      try{
        const res = await previewMessage(this.$route.params.id, this.$route.params.message_id)
        if(!(res.status==200 && res.data.status=='success'))
          throw res.statusText;
        this.message = res.data.data.message;
        this.subject = res.data.data.subject;
      }catch(error) {
        this.$vs.notify({
					title: this.$t('FailedToLoadData'),
					text: error,
					color: "danger",
					position: "top-center"
				});
				console.error(error);
      }
    }
	}


}
</script>

<style>

</style>